import { createIcon } from '@chakra-ui/react'

export const SuccessCheckIcon = createIcon({
  displayName: 'SuccessCheckIcon',
  path: (
    <path
      d='M16.4167 36.9582L7.25 27.7915L10.4812 24.5603L16.4167 30.4728L31.5188 15.3707L34.75 18.6248L16.4167 36.9582ZM21 0.291504L0.375 9.45817V23.2082C0.375 35.9269 9.175 47.8207 21 50.7082C32.825 47.8207 41.625 35.9269 41.625 23.2082V9.45817L21 0.291504Z'
      fill='#79C62B'
    />
  ),
  viewBox: '0 0 42 51',
})
